module.exports = __webpack_public_path__ + "img/Weapon_18.23bddd48.png";